/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/shared/device_profile_type';
import '../model/shared/device_profile_template_type';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "ListDeviceProfileV2TemplateTypesRequest": {
                        "fields": {
                          "deviceProfileType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ListDeviceProfileV2TemplateTypesResponse": {
                        "fields": {
                          "templateTypes": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileTemplateType",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.ListDeviceProfileV2TemplateTypesRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.ListDeviceProfileV2TemplateTypesResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListDeviceProfileV2TemplateTypesRequest @ squareup/devicesettings/profiles/v2/message/list_template_types.proto at 11:1
 */
export const ListDeviceProfileV2TemplateTypesRequest = $root.lookupType('squareup.devicesettings.profiles.v2.message.ListDeviceProfileV2TemplateTypesRequest');
fixType(ListDeviceProfileV2TemplateTypesRequest);
Builder.createAndAttachToType(ListDeviceProfileV2TemplateTypesRequest);
/**
 * SOURCE ListDeviceProfileV2TemplateTypesResponse @ squareup/devicesettings/profiles/v2/message/list_template_types.proto at 15:1
 */
export const ListDeviceProfileV2TemplateTypesResponse = $root.lookupType('squareup.devicesettings.profiles.v2.message.ListDeviceProfileV2TemplateTypesResponse');
fixType(ListDeviceProfileV2TemplateTypesResponse);
Builder.createAndAttachToType(ListDeviceProfileV2TemplateTypesResponse);